import type { SaveState } from "./save.ts";

/**
 * First steps: one short line at a time for a new scout, read off their own stats, so it moves on
 * by itself the moment they have done the thing. Null once the opening loop (walk, battle, catch,
 * duel a trainer) has been played.
 */
export function firstStep(s: Pick<SaveState, "stats" | "defeatedTrainers">): string | null {
  const st = s.stats;
  if (st.steps < 20) return "Arrows / D-pad: walk. Shift: run. Esc: menu.";
  if (st.wildWins + st.caught === 0) return "Walk through tall grass to meet a wild meme.";
  if (st.caught === 0) return "In battle: weaken it, then PACK > Meme Tin.";
  if (st.trainerWins === 0 && s.defeatedTrainers.length === 0) return "Trainers with a ! want a duel. Face them, A.";
  return null;
}
